// pages/tasks/hooks/useTaskTabs.ts
import { useState, useEffect, useMemo } from "react";
import { tasksApi } from "@/api/endpoints/tasks";

export const useTaskTabs = () => {
  const [activeTab, setActiveTab] = useState("allTasks");
  const [tabCounts, setTabCounts] = useState<Record<string, number>>({});

  const mainTabs = useMemo(
    () => [
      { id: "allTasks", label: "All Tasks", filter: {} },
      { id: "overdue", label: "Overdue", filter: { isOverdue: true } },
      { id: "dueToday", label: "Due Today", filter: { dueToday: true } },
      {
        id: "dueTomorrow",
        label: "Due Tomorrow",
        filter: { dueTomorrow: true },
      },
      {
        id: "dueThisWeek",
        label: "Due This Week",
        filter: { dueThisWeek: true },
      },
      {
        id: "dueNext15Days",
        label: "Due Next 15 Days",
        filter: { dueNext15Days: true },
      },
      {
        id: "dueThisMonth",
        label: "Due This Month",
        filter: { dueThisMonth: true },
      },
    ],
    []
  );

  useEffect(() => {
    const fetchTabCounts = async () => {
      try {
        const res = await tasksApi.getTaskCounts();
        if (res?.data?.counts) setTabCounts(res.data.counts);
      } catch (error) {
        console.error("Failed to fetch tab counts", error);
      }
    };
    fetchTabCounts();
  }, []);

  return {
    activeTab,
    setActiveTab,
    tabCounts,
    mainTabs,
  };
};